import {
    type AfterViewInit,
    Component,
    type ElementRef,
    ViewChild,
    inject,
} from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";

import { PasswordResetInitService } from "./password-reset-init.service";

@Component({
    selector: "app-password-reset-init",
    templateUrl: "./password-reset-init.component.html",
    styleUrls: ["./password-reset-init.component.scss"],
    standalone: false,
})
export class PasswordResetInitComponent implements AfterViewInit {
    private passwordResetInitService = inject(PasswordResetInitService);
    private fb = inject(UntypedFormBuilder);

    error: string;
    success: string;
    resetRequestForm = this.fb.group({
        email: [
            "",
            [
                Validators.required,
                Validators.minLength(5),
                Validators.maxLength(254),
                Validators.email,
            ],
        ],
    });

    @ViewChild("emailField", { static: true }) public emailField: ElementRef;

    ngAfterViewInit(): void {
        this.emailField.nativeElement.focus();
    }

    requestReset(): void {
        this.error = null;
        this.success = null;

        this.passwordResetInitService
            .save(this.resetRequestForm.get(["email"]).value)
            .subscribe({
                next: () => {
                    this.success = "OK";
                },
                error: () => {
                    this.error = "ERROR";
                },
            });
    }
}
